'use client';

import { FaWhatsapp } from 'react-icons/fa';

const WHATSAPP_URL = 'https://wa.me/40769141250';

export default function WhatsAppButton() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactează-ne pe WhatsApp"
      className="fixed flex items-center justify-center rounded-full shadow-lg transition-transform hover:scale-105"
      style={{
        bottom: 'calc(20px + env(safe-area-inset-bottom, 0px))',
        right: 'calc(20px + env(safe-area-inset-right, 0px))',
        width: 56,
        height: 56,
        background: 'oklch(48% 0.20 18)',
        color: '#fff',
        zIndex: 9990,
      }}
    >
      <FaWhatsapp size={30} aria-hidden="true" />
    </a>
  );
}
